import axios from 'axios';
import ss from './Session';

const randomString = (length: number) =>
  new Array(length).fill(0)
    .map((x) => String.fromCharCode(65 + Math.floor(Math.random() * 2) * 32 + Math.floor(Math.random() * 26)))
    .join("");

// eslint-disable-next-line no-template-curly-in-string
const package_version = (((window as any)?.package_version || "NA") === '${package_version}')?"DEV":((window as any)?.package_version || "NA");

export async function logBehavior (what: string, detail: any) {

    if (!detail){
        detail = {}
    }

    if (!detail.page){
        detail.page = window.location.pathname;
    }

    if (!sessionStorage.getItem('sessionid')){
        let currentTime = (new Date()).getTime()/1000;
        let sessionid = localStorage.getItem('sessionid');
        let sessionNumber = 1;
        try {
            sessionNumber = Number(localStorage.getItem('session:number') || "1") || 1;
            if (localStorage.getItem('session:number') && localStorage.getItem('session:number')?.replace(/1/g,'').length === 0){
                sessionNumber = localStorage.getItem('session:number')?.length ?? 1;
            }
        }catch(e){
            console.error('invalid sessionNumber', e);
        }
        if (!sessionid){
            sessionid = randomString(16);
            localStorage.setItem('sessionid', sessionid);
            localStorage.setItem('session:firstStartedAt', currentTime.toString());

            await sendBehavior("sessionStart", {});
        }else {
            sessionNumber += 1;
            await sendBehavior("revisit", {
                interval: currentTime - Number(localStorage.getItem('session:lastStartedAt') || '0'),
                intervalFromStart: currentTime - Number(localStorage.getItem('session:firstStartedAt') || '0'),
                sessionNumber
            });
        }
        localStorage.setItem('session:lastStartedAt', currentTime.toString());
        localStorage.setItem('session:number', sessionNumber.toString());
        sessionStorage.setItem('sessionid', sessionid);
    }

    if (!localStorage.getItem('utm')) {
        let utm = new URLSearchParams(window.location.search);
        let utmObj: Record<string, string> = {};
        utm.forEach((value, key) => {
            utmObj[key.replace('utm_','')] = value;
        });

        localStorage.setItem('utm', JSON.stringify(utmObj));
    }

    return await sendBehavior(what, detail);
}

async function sendBehavior (what: string, detail: any) {
    let sessionid = localStorage.getItem('sessionid');
    if (!detail.page){
        detail.page = window.location.pathname;
    }
    
    if (['127.0.0.1', 'localhost', 'mydomain.com', 'dev.novela.today'].find(domain => window.location.host.indexOf(domain) >= 0)){
        detail.debug = true;
    }
    
    let userid = ss.getCurrentSession().userid;

    let utm: Record<string, string> = {};
    try {
        utm = JSON.parse(localStorage.getItem('utm') || '{}');
    }catch (e) {
        localStorage.setItem('utm', '{}');
    }

    try{
        let res = await axios.post('https://api.novela.today/behavior', {logs:[ {what, userid, sessionid, detail, package_version, utm} ]}, {
            headers: {
                Authorization: `Bearer ${ss.getCurrentSession().jwt}`
            },
            withCredentials: true
        });
        
        if (detail.pixel === 'Lead') {
            (window as any).fbq?.('track', 'Lead');
            (window as any).gtag?.('event', 'conversion', {'send_to': 'AW-604780621/m97JCMLq1vwZEM3wsKAC'});
        }else if (detail.pixel === 'StartTrial'){
            (window as any).fbq?.('track', 'StartTrial', {predicted_ltv: 2000, currency: 'KRW'});
            (window as any).gtag?.('event', 'conversion', {'send_to': 'AW-604780621/qTXfCLbp4PgBEM3wsKAC'});
        } else if (detail.pixel === 'Subscribe'){
            (window as any).fbq?.('track', 'Subscribe');
        } else if (detail.pixel === 'Purchase'){
            (window as any).fbq?.('event', 'purchase', detail);
            (window as any).gtag?.('event', 'conversion', {
                ...detail,
                'send_to': 'AW-604780621/qbLYCMy8kpcaEM3wsKAC',
            });

        }

        if (res.data && res.data.code === 200){
            
            return true;

        }else{
            return false;
        }
    }catch(e){
        return false;
    }
}

export async function logBulkBehavior (arr: {what: string, detail: any}[]) {
    
    
    let userid = ss.getCurrentSession().userid;
    let sessionid = localStorage.getItem('sessionid');

    let logs = arr.map(row => ({
        sessionid,
        userid,
        what: row.what,
        package_version,
        detail: {
            page: window.location.pathname,
            ...(row.detail),
            ...((['127.0.0.1', 'localhost', 'mydomain.com', 'dev.novela.today'].find(domain => window.location.host.indexOf(domain) >= 0))
                ?{debug: true}:{})
        },
    }))
    try{
        let res = await axios.post('https://api.novela.today/behavior', {logs}, {
            headers: {
                Authorization: `Bearer ${ss.getCurrentSession().jwt}`
            },
            withCredentials: true
        });

        if (res.data && res.data.code === 200){
            
            return true;

        }else{
            return false;
        }
    }catch(e){
        return false;
    }
}